














































import Vue from "vue";
export default Vue.extend({
  name: "CreateGrayscale",
  data() {
    return {
      dialog: false,
      ruleForm: {
        external: false,
        grayscale: "BLUEGREEN"
      }
    };
  },
  methods: {
    show() {
      this.dialog = true;
    },
    quit() {
      this.dialog = false;
      this.ruleForm = {
        external: false,
        grayscale: "BLUEGREEN"
      };
    },
    submit() {
      this.$emit("createGrayscale", this.ruleForm);
      this.quit();
    }
  }
});
